<template>
  <div>
    <header class="app-header">
      <router-link class="app-header__logo" to="/"><img class="d-none d-md-inline" src="../assets/logo.png"
          alt="Phonenet" /><img class="d-md-none" src="../assets/logo-icon.png" alt="Phonenet" /></router-link>
      <a class="app-sidebar__toggle" href="#" data-toggle="sidebar" aria-label="Menu">
        <font-awesome-icon icon="bars" />
      </a>
      <!-- Navbar Right Menu-->
      <ul class="app-nav">
        <b-nav-item-dropdown right :toggle-class="$store.state.user.avatar ? 'app-nav__item p-0' : 'app-nav__item'"
          :style="$store.state.user.avatar ? 'padding-top: 11px' : ''">
          <template slot="button-content">
            <img v-if="$store.state.user.avatar" :src="$store.state.user.avatar"
              class="rounded-circle border border-light" style="height: 30px; width: 30px;" alt="Avatar" />
            <font-awesome-icon v-else icon="user" size="lg" />
            <span class="d-none d-lg-inline ml-1">
              {{ this.$store.state.user.name }}
              ({{ $t(this.$store.state.user.role) }} <span v-if="$store.state.user.expireTime"> -
                {{ $store.state.user.expireTime | moment('DD/MM/YYYY') }}</span>)
            </span>
          </template>
          <b-dropdown-item @click="profile">
            <font-awesome-icon icon="user" />
            {{ $t('profile') }}
          </b-dropdown-item>
          <b-dropdown-item @click="password">
            <font-awesome-icon icon="key" />
            {{ $t('changePassword') }}
          </b-dropdown-item>
          <b-dropdown-item @click="logout">
            <font-awesome-icon icon="sign-out-alt" />
            {{ $t('logOut') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>
    </header>
    <!-- Sidebar menu-->
    <div class="app-sidebar__overlay" data-toggle="sidebar"></div>
    <aside class="app-sidebar">
      <ul class="app-menu">
        <template v-for="item in menuItems">
          <router-link v-if="!item.items && item.href && checkRole(item.roles)" :key="item.href" :to="item.href"
            v-slot="{ href, navigate, isExactActive }">
            <li>
              <a :class="[isExactActive ? 'active' : '', 'app-menu__item']" :href="href" @click="navigate">
                <span class="app-menu__icon">
                  <font-awesome-icon :icon="item.icon" />
                </span>
                <span class="app-menu__label">{{ item.name }}</span>
              </a>
            </li>
          </router-link>
          <li v-else-if="item.items && checkRole(item.roles)" :key="item.index" class="treeview">
            <a class="app-menu__item" href="#" data-toggle="treeview">
              <span class="app-menu__icon">
                <font-awesome-icon :icon="item.icon" />
              </span>
              <span class="app-menu__label">{{ item.name }}</span><i class="treeview-indicator fa fa-angle-right"></i>
            </a>
            <ul class="treeview-menu">
              <router-link v-for="i in item.items" :key="i.name" :to="i.href"
                v-slot="{ href, navigate, isExactActive }">
                <li v-if="checkRole(i.roles)">
                  <a :class="[isExactActive ? 'active' : '', 'treeview-item']" :href="href" @click="navigate">
                    <i class="icon fa fa-circle-o"></i> {{ i.name }}
                  </a>
                </li>
              </router-link>
            </ul>
          </li>
        </template>
      </ul>
      <lang></lang>
    </aside>
  </div>
</template>

<script>
import Lang from "../components/Lang";
import $ from 'jquery';
import { buildMenuItems, checkMenuRole, menuMessages } from "../menu";

export default {
  components: { Lang },
  computed: {
    menuItems: function () {
      return buildMenuItems(this.$t.bind(this));
    }
  },
  i18n: {
    messages: menuMessages
  },
  watch: {
    // Nav không remount khi điều hướng bằng router-link (SPA), nên logic mở
    // treeview trong mounted() chỉ chạy 1 lần. Mỗi khi đổi route, đồng bộ lại
    // để nhóm menu chứa mục đang active được tự động mở.
    '$route': function () {
      this.$nextTick(this.syncActiveTreeview);
    }
  },
  methods: {
    checkRole: function (roles) {
      return checkMenuRole(roles, this.$store.state.user.role);
    },
    // Mở nhóm treeview chứa mục menu đang active (accordion: đóng các nhóm khác).
    syncActiveTreeview: function () {
      let treeviewMenu = $('.app-menu');
      $('.app-menu a').each(function () {
        if ($(this).hasClass('active')) {
          treeviewMenu.find("[data-toggle='treeview']").parent().removeClass('is-expanded');
          $(this).parents('li.treeview').addClass('is-expanded');
        }
      });
    },
    logout: function () {
      sessionStorage.removeItem('token');
      localStorage.removeItem('token');
      this.$service.defaults.headers.common['token'] = null;
      this.$bgService.defaults.headers.common['token'] = null;
      this.$store.commit('user', null);
      this.$router.push('/login');
    },
    profile: function () {
      this.$store.commit('showProfileForm', true);
    },
    password: function () {
      this.$store.commit('showPasswordForm', true);
    },
  },
  mounted: function () {
    let treeviewMenu = $('.app-menu');
    let viewportGlobal = $(window).width();

    $('[data-toggle="sidebar"]').click(function (event) {
      event.preventDefault();
      $('.app').toggleClass('sidenav-toggled');
    });

    $("[data-toggle='treeview']").click(function (event) {
      event.preventDefault();
      if (!$(this).parent().hasClass('is-expanded')) {
        treeviewMenu.find("[data-toggle='treeview']").parent().removeClass('is-expanded');
        $(this).parent().addClass('is-expanded');
      } else {
        $(this).parent().removeClass('is-expanded');
      }
    });

    $("[data-toggle='treeview'].is-expanded").parent().toggleClass('is-expanded');
    $("[data-toggle='tooltip']").tooltip();

    if (viewportGlobal < 768) {
      $('.app-menu__item').click(function (event) {
        event.preventDefault();
        //$('.app').toggleClass('sidenav-toggled');
      });
    }

    setTimeout(this.syncActiveTreeview, 300);
  }
};
</script>
